import { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export interface Action {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

interface Props {
  actions: Action[];
}

const ActionMenu: React.FC<Props> = ({ actions }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleActionClick = (action: Action) => {
    handleMenuClose();
    window.setTimeout(() => {
      action.onClick();
    }, 0);
  };

  return (
    <div>
      <IconButton onClick={handleMenuOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
      >
        {actions.map((action, index) => (
          <MenuItem key={`am-${action.label}-${index}`} disabled={action.disabled ?? false} onClick={() => handleActionClick(action)}>
            {action.icon} {action.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default ActionMenu;
